import * as React from 'react';

interface ButtonGroupProps {
  readonly children: React.ReactNode;
}

export function ButtonGroup(props: ButtonGroupProps) {
  return <div>{props.children}</div>;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/button-group.tsx